import Layout from "@/components/feature/Layout";
import AboutHeader from "./components/AboutHeader";
import AboutMain from "./components/AboutMain";
import ContactSection from "./components/ContactSection";

function About() {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于嘿咻嘿咻漫画资讯站",
    description:
      "嘿咻嘿咻漫画资讯站：专注剧情解析、结局考据、角色档案与读者讨论的追更信息空间。",
    url: "https://characterz2.github.io/about",
  };

  return (
    <Layout>
      <title>关于我们 - 嘿咻嘿咻漫画资讯站</title>
      <meta
        name="description"
        content="了解嘿咻嘿咻漫画资讯站：品牌介绍、网站定位、发展理念、内容原则与读者口碑，以及投稿合作联系方式。"
      />
      <meta
        name="keywords"
        content="嘿咻嘿咻漫画,关于我们,网站定位,内容原则,联系方式"
      />
      <link rel="canonical" href="https://characterz2.github.io/about" />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>

      <AboutHeader />
      <AboutMain />
      <ContactSection />
    </Layout>
  );
}

export default About;